import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {AccessTokenStorageService} from "@/features/Auth/CurrentUser/Services/AccessTokenStorageService";

const restApiConfig = new RESTAPIConfig();
export const userLangHeaderName = "User-Lang";

export function getAccessToken(state: unknown): string {
    //@ts-ignore
    const tokenFromState = state.currentUser.token;
    if (tokenFromState !== "") {
        return tokenFromState;
    }

    const tokenStorageService = new AccessTokenStorageService();
    return tokenStorageService.getTokenFromStorage();
}

export type TagTypesInterface = typeof tagTypes[number];
const tagTypes = [
    "FetchedData",
    "ContactFormRoles", "CurrentUser", "OrderedTestTypes", "MyOrders",
    "AllOrders", "UsersInCP", "ApplicationsForChangePersonalData",
    "KnowledgeBaseSearchResults", "Appeal", "AppealType", "User", "Analysis", "KnowledgeBaseArticle",
    "FamilyLink", "Sample", "SampleType", "Sampling", "SamplingReferenceBook", "LegalStatus", "ResearchSigns", "OrderTerms",
    "PartnerType", "PregnancyPeculiarity", "ParticipantGenders", "ParticipantDocumentTypes",
    "Partner", "Appeals2Topics", "Appeals2Statuses", "Appeals2Urgency", "Appeals2", "MessageTemplates",
    "ShortInfoOfOrders", "BillStatus", "OrderStatus", "OrderStatuses",
    "CountriesLegalForms", "LegalFormsByCountryId", "CountriesRequisites", "RequisitesByCountryId", "OLFToRequisitesRule",
    "OrderAdditionalServices", "TicketReactionStandard", "Slides", "LabWorkingHours", "StaffWorkingHours",
    "SlotsForEndCustomer", "ReasonsForManagerToRejectSlots", "StatRecordingsToPartners",
    "EmployeesWhoLearntArticle", "PartnersLearning", "PhoneSubjects", "Countries", "Cities", "OrderPriceSettings",
    "AppealsStats", "ResponseTimeStats",
    "DocumentTypes", "LaboratoryLegalEntities", "DocumentStatuses", "Errors",
    "FamilySteps", "FamilyStepsActive", "AttributeSelectionRules", "AttributeSelectionRulesActive", "AttributeRuleForNParticipants", "AttributeRuleForNParticipantsShow", "DescribeKinshipSurveyList", "DescribeKinshipSurveyActiveList",
    "Pedigrees",
    "LaboratoryClarifications", "AnswerTypeRules", "AnswerRuleDictionary", "AnswerRuleDictionaryDocumentTypes", "AnswerRuleProcesses", "AnswerRuleDictionaryByValue",
    "OrderQuestions", "LaboratoryQuestionsStatuses", "TemplateQuestions", "LoginAsLink", "FileExtensions", "FileMeanings", "ActiveFileMeanings", "FileMeaningsToExtensions", "ActiveFileExtensions",
    "OrderLegalStatusReferenceBook", "AnalysisReferenceBook", "FamilyLinkReferenceBook", "OrderTermReferenceBook", "ResearchSignReferenceBook", "SampleReferenceBook", "AdditionalServiceReferenceBook", "GenderReferenceBook", "IdentityDocReferenceBook",
    "Hints", "HintsByAlias", "HintLocations",
    "PartnerProducts", "ClientProducts", "ProductFilterData",
    "MassiveMailingPartnersByManagerId", "TicketTypes", "TicketTopicsReferenceBook", "TicketTransferReasonsReferenceBook", "TicketResponseStatusesReferenceBook", "CountWaitingVisitDate",
    "AnalysisPriceCalculation", "AdditionalServicesPriceCalculation", "ParticipantLimitsPriceCalculation",
    "SamplesPriceCalculation", "ParticipantsPriceCalculation",
    "LkNotifications",
    "ChangeApprovalReferenceBook",
    "SyncListReferenceBook",
    "ChangeApprovalDictionaries",
    "B24SyncRules",
    "ButtonReferences",
    "OrderHistory", "BitrixFields", "BitrixStages", "BitrixFieldsCP",
    "TicketTemplates",
    "UnreadPartnersList",
    "TableFields",
    "SyncBitrixFields",
    "SyncGroupFields",
    "SyncGroups",
    "B24Stages",
    "B24SmartProcesses",
    "B24Funnels",
    "B24Fields",
    "B24BusinessProcesses",
    "LisEntities",
    "Entities1C",
    "B24Tasks",
    "FunctionDescriptionTags",
    "FdLists",
    "ServicePositions",
    "B24CompanyPositions",
    "B24CompanyServices",
    "B24Entities",
    "CourierRequest",
    "TrackNumbers",
    "Roles", "SectionsList", "BlocksList", "PermissionsSections", "Permissions", "MyPermissions",
    "Menu", "CurrentUserMenu",
    "PermissionSectionsDescriptions", "PermissionSectionActionsDescriptions", "PartnersList",
    "ChangeApprovalReferenceBook",
    "SyncListReferenceBook",
    "ChangeApprovalDictionaries",
    "UserCities",
    "ChangeJournalType",
    "NotificationRules",
    "NotificationLogs",
    "FunctionDescription",
    "ResultFileIssues",
    "PartnerFieldsReferenceBook",
    "PartnerFieldCategoriesReferenceBook",
    "PartnerFieldSyncRulesReferenceBook",
    "PartnerFieldListsReferenceBook",
    "PartnerCalculatedGroupsReferenceBook",
    "PartnerSearchColumnCategoriesReferenceBook",
    "PartnerSearchColumnsReferenceBook",
    "PartnerSearchColumnTypes",
    "PartnerSearchColumnGroups",
    "Settings",
    "FinanceSummary",
    "FinanceMovements",
    "FinancePartnerWidget",
    "FinanceMovementDetails",
    "FinanceOrders",
    "FinanceOrderDetails",
    "FinanceSourceTypes",
    "FinanceWriteoffTypes",
    "FinanceFinancialStatuses",
    "EconomistSources",
    "EconomistWriteoffs",
    "EconomistSourceTypes",
    "EconomistWriteoffTypes",
    "EconomistFinancialStatuses",
    "EconomistImportHistory",
    "EconomistErrors",
    "EconomistJournal",
    "TicketSettings",
    "FirstTestTypeReferenceBook",
    "OrderFormFieldRulesReferenceBook", "NonstandardConsentFiles",
    "ManagerTransfers",
    "ChecksumErrors",
    "FinPermissionsReferenceBook",
    "TestingAudience", "TestingState", "TestingQuestionType", "TestingReviewPeriod", "TestingQuestionAnswers",
    "TestingAssignmentType", "TestingRecipient", "TestingPreviousAssignment", "TestingUnit", "TestingAssignments", "TestingTopics", "TestingDocuments", "TestingMaterials", "TestingMaterialTags", "TestingTags", "TestingQuestions", "TestingTests", "TestingHowItWorks", "TestingProgressResults", "TestingMyResults", "TestingMyResult", "TestingMyAssignments", "TestingRecentlyOpened",
    "OrderB24StatusMismatches"
] as const

export const ApiSlice = createApi({
    reducerPath: 'api', // optional
    baseQuery: fetchBaseQuery({
        baseUrl: restApiConfig.baseUrl + restApiConfig.apiPrefix,
        // headers: {
        //     "Content-Type": "application/json;charset=utf-8",
        // },
        prepareHeaders: (headers, api) => {
            //@ts-ignore
            const userLang = api.getState().lang.userLang as string;
            headers.append(userLangHeaderName, userLang);

            const accessToken = getAccessToken(api.getState());
            headers.append("Authorization", `Bearer ${accessToken}`);

            return headers;
        },
    }),
    tagTypes,
    endpoints: builder => ({})
});
